import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'bootstrap-datepicker';
import './app.utility.js';
import { Page, util } from './app.js';
import ThemeToggle from './app.ThemeToggle.js';
import input from './app.input.js';
import grids from './app.grids.js';
import fileUploaders from './app.fileUploaders.js';
import pagecontent from './app.pagecontent.js';
import Autocomplete, { installAutocompletePlugin } from './app.autocomplete.js';
import '../WaMS/customValidators.js';
import $ from 'jquery';

// Install jQuery plugin — must happen before DOM ready so $(el).AutoComplete() works
installAutocompletePlugin();

// Expose all modules on window.app — stable public API for inline scripts in .cshtml files
// e.g. app.grids.refreshGrid(...), app.page.refreshTarget(...), app.util.openModal(...)
window.app = { util, grids, input, pagecontent, fileUploaders, ThemeToggle, Autocomplete };

// Expose jQuery globally so @section scripts can use $ without importing it
window.$ = window.jQuery = $;

$(function () {
    window.app.page = new Page(window.applicationPath);
    ThemeToggle.Init();
    input.Init();
    grids.Init();
    pagecontent.Init();
    $(document).trigger('page-init-complete');
    document.dispatchEvent(new CustomEvent('page-init-complete'));
});
